







































































































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import AudienceAvailabilitySelector from '@ui/AudienceSetWizard/components/AudienceAvailabilitySelector'
import MediaSelector from '@ui/MediaSelector'

settings =
  name: 'OnsiteActivationFormStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      StepContainer,
      AudienceAvailabilitySelector,
      MediaSelector,
    }

    data: ->
      form: null
      selectedAvailabilityKeys: []
      priceInDollars: {}
      mediaModal:
        show: false

    computed:
      actionsForMediaSelector: ->
        onUpload: @onUploadMedia
        onDone: @selectMedia

      pricingTableData: ->
        [
          { name: '10x10:', spaceType: 'space_10x10' },
          { name: '10x20:', spaceType: 'space_10x20' },
          { name: '20x40:', spaceType: 'space_20x40' },
          { name: '40x60:', spaceType: 'space_40x60' },
        ]

    mounted: ->
      @initializeData()
      @initializeSelectedAvailabilityKeys()
      @initializePriceInDollars()

    methods:
      hiSetPriceInCentsForSpaceType: (spaceType, priceInDollars) ->
        @form.price_in_cents[spaceType] = parseInt(priceInDollars) * 100

      hiOpenMediaSelector: ->
        @mediaModal.show = true

      hiSetDefaultImage: (url) ->
        @form.default_image = url
        @rerender()

      initializeData: ->
        if @wizard.selectedOnsiteActivation
          @form = @wizard.selectedOnsiteActivation
          return

        @form = @wizard.prototypeForOnsiteActivation()
        @wizard.audienceSetData.spaces[@form.key] = @form

      initializeSelectedAvailabilityKeys: ->
        @selectedAvailabilityKeys = @wizard.audienceAvailabilitiesForSpace(@form.key).map((item) => item.key)

      initializePriceInDollars: ->
        for key, price of @form.price_in_cents
          @priceInDollars[key] = price / 100
          @priceInDollars[key] ||= null

      addSpaceKeyToAudienceAvailability: (audienceAvailability) ->
        audienceAvailability.space_keys.push @form.key if @form.key not in audienceAvailability.space_keys

      removeSpaceKeyToAudienceAvailability: (audienceAvailability) ->
        audienceAvailability.space_keys = audienceAvailability.space_keys.filter((key) => key isnt @form.key)

      feeForSpaceTypeInCents: (spaceType) ->
        priceInCents = parseInt(@form.price_in_cents[spaceType] || '0')
        takePercentage = @standardPricingTable()[spaceType]?.take_percentage || 0
        feeInCents = priceInCents * takePercentage / 100
        feeInCents
      feeForSpaceTypeInDollars: (spaceType) ->
        @feeForSpaceTypeInCents(spaceType) / 100

      payoutForSpaceTypeInCents: (spaceType) ->
        priceInCents = parseInt(@form.price_in_cents[spaceType] || '0')
        payoutInCents = priceInCents - @feeForSpaceTypeInCents(spaceType)
        payoutInCents
      payoutForSpaceTypeInDollars: (spaceType) ->
        @payoutForSpaceTypeInCents(spaceType) / 100

      selectMedia: (selectedKeys) ->
        @form.images = [...selectedKeys]

      onUploadMedia: (file) ->
        @wizard.fetch 'supplier_media_kit'

    watch:
      selectedAvailabilityKeys: (selectedKeys) ->
        for audienceAvailability in @wizard.audienceSetData.audience_availabilities
          if audienceAvailability.key in selectedKeys
            @addSpaceKeyToAudienceAvailability audienceAvailability
          else
            @removeSpaceKeyToAudienceAvailability audienceAvailability

export default VueOptions.vue settings
